import { Controller } from "@hotwired/stimulus";
import { fillInput, selectOptionFor } from "../../../utils/inputs_utils";
import { interpolate } from "../../../utils/string_utils";

/* NOTE(Jonathan Jalal): Not ideal to leak these technical statuses here, but with our current way of filling the sales invoice form, we don't have the choice */
const SALES_INVOICE_STATUSES = {
  VALIDATED_SALES_INVOICE: 1,
  DRAFT_CREDIT_NOTE: 10,
  VALIDATED_CREDIT_NOTE: 11,
};

export default class extends Controller {
  static targets = [
    "invoiceType",
    "invoiceCustomer",
    "invoiceReference",
    "invoiceCurrency",
    "invoiceDate",
    "invoiceDueDate",
    "lineTemplate",
    "invoiceLinesContainer",
  ];

  connect() {
    this.element.addEventListener("accountingDocument:processedFormReady", (e) => {
      if (e.detail.sales_invoice) {
        this._fillForm(e.detail.sales_invoice, e.detail.sales_invoice_lines);
      } else {
        this._fillEmptyForm();
      }
    });

    document.addEventListener("accountingDocument:validated", (e) => {
      const bankTransactionAttached = e.detail.bank_transaction;
      const detail = bankTransactionAttached ? { bank_transaction: bankTransactionAttached } : {};

      document.dispatchEvent(new CustomEvent("salesInvoicePdf:uploaded", { detail }));
    });
  }

  _fillEmptyForm() {
    // NOTE(Jonathan Jalal): We call this even in case of OCR processing timeout, to create an empty sales invoice line in the form
    // Without this, the CTA to add a new line does not work (it relies on the presence of at least one existing line to add another line after it)
    this._fillForm({}, [{}]);
  }

  _fillForm(salesInvoice, salesInvoiceLines) {
    const invoiceTypeTarget = this.invoiceTypeTargets.find((target) => {
      const targetValue = this._isCreditNote(salesInvoice)
        ? SALES_INVOICE_STATUSES.VALIDATED_CREDIT_NOTE
        : SALES_INVOICE_STATUSES.VALIDATED_SALES_INVOICE;
      return parseInt(target.value) === targetValue;
    });
    invoiceTypeTarget.checked = true;

    selectOptionFor(this.invoiceCustomerTarget, salesInvoice.customer_id);
    fillInput(this.invoiceReferenceTarget, salesInvoice.reference);
    selectOptionFor(this.invoiceCurrencyTarget, salesInvoice.currency);
    fillInput(this.invoiceDateTarget, salesInvoice.date);
    fillInput(this.invoiceDueDateTarget, salesInvoice.due_date);

    salesInvoiceLines.forEach((line, index) => {
      const lineTemplateContent = interpolate(this.lineTemplateTarget, { index: index, invoice_line: line });
      this.invoiceLinesContainerTarget.insertAdjacentHTML("beforeEnd", lineTemplateContent);

      document.dispatchEvent(new CustomEvent("salesInvoice:lineUpdated"));
    });
  }

  _isCreditNote(salesInvoice) {
    return [SALES_INVOICE_STATUSES.DRAFT_CREDIT_NOTE, SALES_INVOICE_STATUSES.VALIDATED_CREDIT_NOTE].includes(
      salesInvoice.status
    );
  }
}
